import { Container, Divider, Stack } from '@chakra-ui/react'
import { SelectedOrgChecker } from '@features/organisations/components/SelectedOrgChecker'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import {
  DEFAULT_LIST_ORDER,
  listOrgSessionRequestSchema,
  SESSION_ORDER_BY_FIELDS,
} from '@customTypes/cloudmix/sessions'
import { OrgSessionsTableContainer } from '@features/sessions/components/OrgSessionsTableContainer'
import { ActiveSessionsSection } from '@features/sessions/components/ActiveSessionsSection'
import { withListHydration } from '@lib/listState/withListHydration'

const ListSessionsRoute = () => (
  <Container maxW={'75rem'}>
    <SelectedOrgChecker>
      <Stack spacing={8}>
        <ActiveSessionsSection />
        <Divider />
        <OrgSessionsTableContainer />
      </Stack>
    </SelectedOrgChecker>
  </Container>
)

const routerSchema = listOrgSessionRequestSchema.partial().catch({})
export const Route = createFileRoute('/_auth/o/$orgId/sessions/')({
  component: ListSessionsRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {
      defaultSort: DEFAULT_LIST_ORDER,
      allowedOrderByFields: SESSION_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Sessions',
  }),
})
